export default __webpack_public_path__ + "assets/icons/pdf.329649a6.svg";